import { ReactComponent as WhiteArrow } from "../Asset/greaterwhite.svg";
import { Link } from "react-router-dom";
import "./notfound.css";

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="wrap">
        <h2 className="error-code">404</h2>
        <p className="error-message">We could not find the page you're looking for...</p>
        <Link to="/" className="back-home-btn">
          Back Home <WhiteArrow />
        </Link>
        <img
          className="not-found-image"
          src="https://res.cloudinary.com/du44pwjoi/image/upload/v1737374116/Heavy_Lift_Pipe-lay_Multi_Purpose_Vessel.I15.2k_2_wolkb9.png"
          alt="Ship"
        />
      </div>
    </div>
  );
};

export default NotFound;
